<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('fitnessAge.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit">{{$t('fitnessAge.unit')}}</div>
            </div>
            <div id="chart-box"></div>
            <div class="legend-box">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-text1 legend-text"> >{{$t('fitnessAge.actualAge')}}</div>
                <div class="legend-text2 legend-text"> ={{$t('fitnessAge.actualAge')}}</div>
                <div class="legend-text3 legend-text"> &lt;{{$t('fitnessAge.actualAge')}}</div>
            </div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}</div>
                        <div class="math-text">{{$t('fitnessAge.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}</div>
                        <div class="math-text">{{$t('fitnessAge.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}</div>
                        <div class="math-text">{{$t('fitnessAge.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('fitnessAge.descTitle')}}</div>
            <div class="desc-info desc-last">
                {{$t('fitnessAge.desc')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'fitnessAge',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                ageInfo: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch:{
            showTimeBox:{
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('fitnessAge.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 0) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 1) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            getData() {
                this.checkOpacity();
                this.$api.status.queryFitnessAge({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.ageInfo = res.info;
                        this.mathData.maxData = res.info.math.max;
                        this.mathData.avgData = res.info.math.avg;
                        this.mathData.minData = res.info.math.min;
                        this.ageInfo.dateArr = [];
                        this.ageInfo.dataArr = [];
                        for (let i = 0; i < this.ageInfo.data.length; i++) {
                            this.ageInfo.dateArr.push(this.ageInfo.data[i].date);
                            let color;
                            let data = this.ageInfo.data[i].fitnessAge;
                            if (data > 0) {
                                color = this.getAgeColor(this.ageInfo.age, data)
                            } else {
                                data = null
                            }
                            let style = {
                                value: data,
                                itemStyle: {
                                    color: color
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: color,
                                        borderWidth: 1.5 * this.ratio,
                                        color: 'transparent'
                                    }
                                }
                            }
                            this.ageInfo.dataArr.push(style);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            getAgeColor(age, fitnessAge) {
                let color;
                if (fitnessAge < age) {
                    color = getSkin('--chart-color-8');
                } else if (fitnessAge == age) {
                    color = getSkin('--chart-color-1');
                } else {
                    color = getSkin('--chart-color-3');
                }
                return color;
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.ageInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    let _this = this;
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> '+(_this.$i18n.locale == 'en' ? '' :'岁')+'</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.ageInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: this.ageInfo.dataArr,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            }
        }
    }
</script>

<style scoped>
    #chart-box {
        height: 198px;
        width: 100%;
    }

    .chart-unit {
        position: absolute;
        font-size: 11px;
        color: var(--text-color-3);
        left: 20px;
        top: 20px;
    }

    .legend-box {
        width: 100%;
        height: 30px;
        /*background-color: #20D38F;*/
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-3);
        left: 41px;
        top: 6px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-1);
        left: 161px;
        top: 6px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-8);
        left: 275px;
        top: 6px;
    }

    .legend-text {
        position: absolute;
        font-size: 10px;
        color: var(--text-color-2);
    }

    .legend-text1 {
        top: 3px;
        left: 54px;
    }

    .legend-text2 {
        top: 3px;
        left: 174px;
    }

    .legend-text3 {
        top: 3px;
        left: 288px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/10fitnessAge.vue